/* eslint strict: ["warn"], no-use-before-define: ["warn"] */

(function ($) {
	$.fn.silknav = function (options) {
		var settings = $.extend({
			parentEl: 'a',
			heightOffset: 1,
			homeLink: '/',
			homeLinkText: 'Home'
		}, options);

		function shift($el, length, offset) {
			// Calculate move value
			var move = ((length - offset) * 100) * -1;

			// Move
			$el.find('> ul').css('left', move + '%');
		}

		function menuaimActivate(row) {
			var $row = $(row);

			$row.addClass('hover');

			if ($row.hasClass('parent')) {
				var $child = $row.find('> ul:first');
				var $parent = $row.parent('ul');
			}
		}

		function menuaimDeactivate(row) {
			$(row).removeClass('hover');
		}

		function menuaimExitMenu(menu) {
			return true;
		}

		function resizeMenu($el) {

			// Get elements needed for calculating height
			var els = {
				openMenu: $nav.find('.is-opened'),
				homeLink: $nav.find('.site-home:first'),
				clonedSearch: $nav.find('.main-nav-search--clone:first')
			};

			// Get heights
			var openMenuHeight = (els.openMenu.length) ? els.openMenu.outerHeight() : 0;
			var homeLinkHeight = (els.homeLink.length) ? els.homeLink.outerHeight() : 0;
			var clonedSearchHeight = (els.clonedSearch.length) ? els.clonedSearch.outerHeight() : 0;

			// Calculate overall height
			var height = openMenuHeight + homeLinkHeight + clonedSearchHeight;

			// Set height of nav
			if (height > 0) {
				$nav.css({
					height: height + 'px'
				});
			} else {
				$nav.css({
					height: 'auto'
				});
			}
		}

		function showActive() {
			/*
			activeLink();

			var $current = $nav.find('.is-opened');
			var $depth = $current.parents('ul').length;

			$nav.find('.parent ul').addClass('nav-hidden-mobile');
			$current.removeClass('nav-hidden-mobile');
			$current.parents('ul').removeClass('nav-hidden-mobile');

			shift($nav, $depth, 0);
			resizeMenu();
			*/

		}

		function activeLink() {
			// Remove is-opened from all
			$nav.find('ul').not('.group').removeClass('is-opened').addClass('nav-hidden-mobile');

			var path = window.location.pathname;
			var currentPage = $nav.find('ul li a[href$="' + path + '"]');

			// If Home Page
			if (path === $('.home-link a').attr('href')) {
				$nav.find('> ul').addClass('is-opened');

			} else if (currentPage.length > 0) {
				if (currentPage.siblings('ul').length > 0) {
					currentPage.siblings('ul').addClass('is-opened');
				} else {
					currentPage.closest('ul').addClass('is-opened');
				}
			}
		}

		function onRoot() {
			/* var path = window.location.pathname;
			if ( $nav.find('> ul').hasClass('is-opened')) {
				if( path === "/") {
					return true;
				} else {
					return false;
				}

			} else {
				return false;
			} */
		}

		function hideSiteHome() {
			/* var $siteHome = $nav.find('.site-home');

			if (onRoot()) {
				$siteHome.find('.home-link').fadeTo('fast', 0);
			} else {
				$siteHome.find('.home-link').fadeTo('fast', 1);
			}

			if ($('.micro-site #nav > ul').hasClass('is-opened')) {
				$('.micro-site .home-link button').fadeTo('fast', 0);
			} else {
				$('.micro-site .home-link button').fadeTo('fast', 1);
			} */

		}

		function goToTopLevel() {
			shift($nav, 1, 1);
			hideSiteHome();
			resizeMenu();
		}

		var $this = $(this);

		$('body').on('data-drawer-close-state', function () {
			$this.find('ul').removeClass('is-opened');
			showActive();
		});

		var $nav = $this;
		var $homeLink = $nav.find('.home-link');
		var homeLink = {};

		if (!$homeLink.length) {
			homeLink.href = settings.homeLink;
			homeLink.text = settings.homeLinkText;
		} else {
			homeLink.href = $homeLinkAnchor.attr('href');
			homeLink.text = $homeLinkAnchor.text();
		}

		var $homeLinkAnchor = $homeLink.find('a');

		var globalOutput = '<div class="site-home trays--active">' +
			'<div class="home-link">' +
			'<a href="' + homeLink.href + '">' + homeLink.text + '</a>' +
			'<button class="trigger__back icon icon-chevron-thin-left" aria-label="Back"><span class="visually-hidden">Back to Home</span></button>' +
			'</div>' +
			'</div>';

		// $nav.prepend(globalOutput);
		$homeLink.remove();

		$nav.find('.home-link button').click(function () {
			$nav.find('> ul').addClass('is-opened');
			goToTopLevel();
		});

		showActive();
		hideSiteHome();
		setTimeout(resizeMenu, 300);

		return this.each(function () {

			// Shortcut to nav element
			var $nav = $(this);

			// Add parent class to sub menus
			$nav.find(settings.parentEl).each(function () {
				// Get child element
				var $child = $(this).next('ul');

				// If we have a child...
				if ($child.length) {
					// Add parent class
					$(this).parent().addClass('parent');
					// Create next link
					$(this).append('<button aria-label="Next" class="next tray__trigger icon icon-chevron-thin-right" />');
					// Create back link
					$child.prepend($('<li class="whereami"><button class="back trigger__back icon icon-chevron-thin-left"><span class="visually-hidden">Back</span></button><a href="' + $(this).attr('href') + '">' + $(this).text() + '</a></li>'));
				}

			// Attach behaviour for clicking parent element
			}).end().find('.parent > ' + settings.parentEl + ' > .next').click(function (e) {
				// Stop href from firing
				e.preventDefault();

				var $currentlyOpen = $(this).parent().siblings('ul');

				$nav.find('ul').removeClass('is-opened');
				$currentlyOpen.addClass('is-opened');


				// Get siblings so we can adjust z-index
				$(this).parent().parent().find('> ul').removeClass('nav-hidden-mobile').end().siblings().find('> ul').addClass('nav-hidden-mobile');

				// Shift nav
				shift($nav, $(this).parents('li').length, 0);
				hideSiteHome();
				resizeMenu();

			// Attach behaviour for clicking back button
			}).end().find('.back').click(function (e) {
				// Stop href from firing
				e.preventDefault();
				var openedChild = $nav.find('.is-opened');
				var parent = openedChild.parent().parent();

				$nav.find('ul').removeClass('is-opened');
				parent.addClass('is-opened');

				// Shift nav
				shift($nav, $(this).parents('li').length, 2);
				hideSiteHome();
				resizeMenu();
			});

		});
	};

}(jQuery));

jQuery(function($) { // DOM load

	// Elements
	var $body = $('body'),
		$header = $('#header:first'),
		$paintBucket = $('#paint_bucket:first'),
		$nav = $('#main_nav > .container > div:first'),
		$searchClone = $('.main-nav-search:first').clone().addClass('main-nav-search--clone');

	// Create SILK nav and prepend cloned search
	$nav.silknav({
		'homeLink' : 'http://jhsph.edu/'
	}).prepend($searchClone);

	// Add nav toggle + mobile search toggle
	var $mobileTriggerHTML = '<a href="#" id="main_nav--trigger">Main menu<span></span><span></span><span></span><span></span></a>'
		+ '<button class="search-modal__toggle" id="mobile-search-trigger" aria-label="Open search" aria-expanded="false" aria-controls="search-modal">'
		+ '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false" width="22" height="22">'
		+ '<path d="M21 21l-4.35-4.35M17 11A6 6 0 1 1 5 11a6 6 0 0 1 12 0z" stroke="currentColor" stroke-width="2" stroke-linecap="round" fill="none"/>'
		+ '</svg></button>';
	$paintBucket.before($mobileTriggerHTML);
	$('#main_nav--trigger').click(function(e) {

			// Prevent default behavior
			e.preventDefault();

			// Shortcut to this
			var $this = $(this);

			// Toggle body class for CSS styles
			$body.toggleClass('mobile-nav-open');

			// Toggle class for animation between hamburger and close icon
			$this.toggleClass('open');

			// Show or hide nav, pushing the page content down in sync
			var $banner = $('.cent-inst_featuredImg, .dialog-off-canvas-main-canvas');
			var headerHeight = $header.outerHeight();
			if ($this.hasClass('open')) {
				$('#main_nav').css({ position: 'fixed', top: headerHeight + 'px', left: 0, width: '100%', zIndex: 1200, background: 'linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)) #002E75' });
				$nav.slideDown({
					duration: 400,
					progress: function() {
						$banner.css('margin-top', (headerHeight + $nav.outerHeight()) + 'px');
					},
					complete: function() {
						$banner.css('margin-top', (headerHeight + $nav.outerHeight()) + 'px');
					}
				});
			} else {
				$nav.slideUp({
					duration: 300,
					progress: function() {
						$banner.css('margin-top', (headerHeight + $nav.outerHeight()) + 'px');
					},
					complete: function() {
						$banner.css('margin-top', '');
						$nav.css('padding-top', '');
						$('#main_nav').css({ position: '', top: '', left: '', width: '', zIndex: '' });
						$nav.hide();
					}
				});
			}

		})
	.end();

});
